const PATIENT_NO_SHOW = 'patientNoShow';

export default PATIENT_NO_SHOW;
